import { getLocationSearch } from './getLocationSearch';
export default function getCurrentUrl() {
  const params = new URLSearchParams(getLocationSearch());
  // eslint-disable-next-line no-restricted-syntax
  const url = params.get('completeHostUrl') || window.location.href;
  return decodeURIComponent(url);
}